import Darkmode from "./darkmode";

export default {
  install(Vue, options) {
    Vue.prototype.$darkmode = new Darkmode(options);
  }
}
